import { appFirebase, auth, dbFirestore, dbRealtime } from './firebaseconfig'
import firebase from "firebase/compat/app";
import { reduxStore, dispatch } from '../redux/store';
import { getAuth, signOut, fetchSignInMethodsForEmail, createUserWithEmailAndPassword, signInWithEmailAndPassword, deleteUser } from 'firebase/auth';
import { getFirestore } from "@firebase/firestore";
import {
    getDocs,
    collection,
    addDoc,
    deleteDoc,
    updateDoc,
    doc,
    setDoc,
} from "firebase/firestore";
import { getDatabase, ref, set, get, child, push, update, remove } from 'firebase/database';

export const firebaseMethods = {
    // firebase helper methods go here... 
    signup: async (body) => {
        const { email, password } = body
        await createUserWithEmailAndPassword(getAuth(appFirebase), email, password)
            //make res asynchonous so that we can make grab the token before saving it.
            .then(async res => {
                // {
                //     "kind": "identitytoolkit#SignupNewUserResponse",
                //     "idToken": "eyJhbGciOiJSUzI1NiIsImtpZCI6IjNiYjg3ZGNhM2JjYjY5ZDcyYjZjYmExYjU5YjMzY2M1MjI5N2NhOGQiLCJ0eXAiOiJKV1QifQ.eyJpc3MiOiJodHRwczovL3NlY3VyZXRva2VuLmdvb2dsZS5jb20vZS10cmFkaW5nLTYxNDNlIiwiYXVkIjoiZS10cmFkaW5nLTYxNDNlIiwiYXV0aF90aW1lIjoxNzA5MzcyNzQ1LCJ1c2VyX2lkIjoiYnhCSkhDSjcxMWcyMW54b0lKeGF1WnJPOUplMiIsInN1YiI6ImJ4QkpIQ0o3MTFnMjFueG9JSnhhdVpyTzlKZTIiLCJpYXQiOjE3MDkzNzI3NDUsImV4cCI6MTcwOTM3NjM0NSwiZW1haWwiOiJkb25hbWtoYW5oQGdtYWlsLmNvbSIsImVtYWlsX3ZlcmlmaWVkIjpmYWxzZSwiZmlyZWJhc2UiOnsiaWRlbnRpdGllcyI6eyJlbWFpbCI6WyJkb25hbWtoYW5oQGdtYWlsLmNvbSJdfSwic2lnbl9pbl9wcm92aWRlciI6InBhc3N3b3JkIn19.jjw_wL42nWj2ebSbRknRjgandPDzXVJP2WJNn3NTv2vyTmf1pfsir2vsti4c2N71NdFAONhIG_J4PMZ08qrx8cEr0Ec26Gr0NcVtH3mCwK7ayGTzh2AmjAPirBMe_yatzC9CFKeUo3begJB_wBzrpPavcthj2r4a3jcH8IDohsd6A0D10goxAZI1_mDfIDPaciY7FNrv9z8riwSExmv6FGc2z7HDzUMM7awghf6iqQIA2Zp_BVRuEc4gu3X94NWsozaLlQ79EoyOgU8Kp8w7nTyO-zdJVKroa5qDl8WRLrwsOWDMt_XJyseUHFpc0dUezkpwO-kAdqLYfLUEeaSU1A",
                //     "email": "donamkhanh@gmail.com",
                //     "refreshToken": "AMf-vBwuB3ic15HEViHc1kyzu_oEHzLzy-RdkbvZz7zKWdylR-X3K5Wmq4rK9qelho6eEjajcevUPjxUFi0lGrlgk2b1g8u-fg1yvY46vP6Q4fR5AUQxJKffuzRErLMx-IPmenrstv26MunpCno0rgcdQ67T0EqnN15Sj2-HU-ny_VbIQ_cYEy9sE2zOZcxCEZvGre2E7I_kRxN3cQejWrA1dorFCNpgxw",
                //     "expiresIn": "3600",
                //     "localId": "bxBJHCJ711g21nxoIJxauZrO9Je2"
                //   }
                return res && res.user
            })
            .catch(err => {
                throw err; // Ném lỗi để bắt ở phần gọi hàm login
            })
    },
    login: async (body) => {
        const { email, password } = body;
        try {
            const res = await signInWithEmailAndPassword(getAuth(appFirebase), email, password);
            return res.user; // Trả về user object từ phản hồi
        } catch (err) {
            throw err; // Ném lỗi để bắt ở phần gọi hàm login
        }
    },
    //no need for email and password
    logout: async () => {
        // signOut is a no argument function
        await signOut(getAuth(appFirebase))
            .then(res => {
                //remove the token
                //set the token back to original state
            })
            .catch(err => {

            })
    },
    deleteAccount: async (email) => {
        try {
            const user = await fetchSignInMethodsForEmail(getAuth(appFirebase), email);

            // Kiểm tra xem người dùng có tồn tại không trước khi xóa
            if (user) {
                // Xóa người dùng khỏi Firebase Authentication
                await deleteUser(getAuth(appFirebase), user.uid);
            } else {
            }
        } catch (error) {
            throw error; // Re-throw the error to be caught in the calling function
        }
    },
    uploadProfileImage: (imageBytes64Str) => {
        // const bucket = admin.storage().bucket()
        // const imageBuffer = Buffer.from(imageBytes64Str, 'base64')
        // const imageByteArray = new Uint8Array(imageBuffer);
        // const file = bucket.file(`images/profile_photo.png`);
        // const options = { resumable: false, metadata: { contentType: "image/jpg" } }

        // //options may not be necessary
        // return file.save(imageByteArray, options)
        //     .then(stuff => {
        //         return file.getSignedUrl({
        //             action: 'read',
        //             expires: '03-09-2500'
        //         })
        //     })
        //     .then(urls => {
        //         const url = urls[0];
        //         console.log(`Image url = ${url}`)
        //         return url
        //     })
        //     .catch(err => {
        //         console.log(`Unable to upload image ${err}`)
        //     })
    },
    setDataToFirebase: async (key, path, data) => {
        if (!key) {
            return
        }
        try {
            await setDoc(doc(dbFirestore, path, key), data);
        } catch (err) {
            throw err; // Re-throw the error to be caught in the calling function
        }
    },
    getDatafromFirebase: async (key, path) => {
        const myCollection = collection(dbFirestore, path);
        try {
            const querySnapshot = await getDocs(myCollection);
            let data = {}
            querySnapshot.forEach((doc) => {
                // data = doc.data()
                data[doc.id] = doc.data();
            });
            return (data && data[key]) || {}
            // return querySnapshot
        } catch (err) {
            throw err; // Re-throw the error to be caught in the calling function
        }
    },
    updateDataInFirebase: async (key, path, data) => {
        if (!key) {
            return;
        }
        try {
            const docRef = doc(dbFirestore, path, key);
            await updateDoc(docRef, data);
        } catch (err) {
            throw err; // Re-throw the error to be caught in the calling function
        }
    },
    setDatabaseInFirebase: async (path, data) => {

        if (!path) {
            return;
        }

        try {
            const dbRef = ref(dbRealtime, path);
            await push(dbRef, data);
        } catch (error) {
            throw error; // Re-throw the error to be caught in the calling function
        }
    },
    getDatabaseInFirebase: async (path) => {
        const dbRef = ref(dbRealtime);
        try {
            const snapshot = await get(child(dbRef, path));
            if (snapshot.exists()) {
                return snapshot.val();
            } else {
                return null; // Return null or an appropriate value when no data exists
            }
        } catch (error) {
            throw error; // Re-throw the error to be caught in the calling function
        }
    },
    updateDatabaseInFirebase: async (updates) => {
        const dbRef = ref(dbRealtime);
        try {
            await update(dbRef, updates);
        } catch (error) {
            throw error; // Re-throw the error to be caught in the calling function
        }
    },
    removeDatabaseInFirebase: async (path) => {
        const dbRef = ref(dbRealtime);
        try {
            await remove(dbRef.child(path));
        } catch (error) {
            throw error; // Re-throw the error to be caught in the calling function
        }

        // let record = _.cloneDeep(_record)
        // const pathToRemove = '/listContact/' + record.id;
        // await firebaseMethods.removeDatabaseInFirebase(pathToRemove)
        //     .then(res => {
        //         ToastUtil.success("Xóa thành công");
        //     })
        //     .catch(error => {
        //         ToastUtil.errorApi(error, "Xóa thất bại");
        //     });
    },
}